import React, { useState, useEffect, useContext } from 'react'
import { Box } from '@mui/system'
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Chip, OutlinedInput } from '@mui/material'
import Sidebar from './sidebar'
import { DataGrid } from '@mui/x-data-grid'
import { db } from '../firebase'
import dayjs from 'dayjs'
import { collection, query, getDocs } from "firebase/firestore"
import { useNavigate } from 'react-router-dom'
import CustomToolbar from './CustomToolbarPrint'
import DataContext from '../context/context'
import getDropDownData from './hook/getDropDownData'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ActivityLogViewer() {
    const [dateFrom, setDateFrom] = useState("")
    const [dateTo, setDateTo] = useState("")
    const [selectedActivities, setSelectedActivities] = useState([])
    const [rows, setRows] = useState([])
    const [activityOptions, setActivityOptions] = useState([])
    const dropdata = useContext(DataContext)

    useEffect(() => {
        if (!dropdata) {
            getRewindData();
        } else {
            setActivityOptions(dropdata.LogActivity || []);
        }
    }, [dropdata]);

    let getRewindData = async () => {
        let a = await getDropDownData();
        setActivityOptions(a.LogActivity || []);
    };

    async function getData() {
        console.log("Fetching activity data...")
        let arr = []
        const q = query(collection(db, "LogActivity"));
        const querySnapshot = await getDocs(q);
        
        querySnapshot.forEach((doc) => {
            let obj = doc.data();
            Object.assign(obj, { doc: doc.id });
            
            // Check if date is within range
            if (dateCheck(dateFrom, dateTo, obj.activityDate)) {
                // Check if activity is selected (if any activities are selected)
                if (selectedActivities.length === 0 || selectedActivities.includes(obj.activityName)) {
                    arr.push(obj)
                }
            }
        });
        
        setRows(arr)
        console.log("Found", arr.length, "activities")
    }

    function dateCheck(from, to, check) {
        if (!from || !to) return true; // If no date range is set, show all
        
        var fDate, lDate, cDate;
        fDate = Date.parse(from);
        lDate = Date.parse(to);
        cDate = Date.parse(check);

        if ((cDate <= lDate && cDate >= fDate)) {
            return true;
        }
        return false;
    }

    const handleActivityChange = (event) => {
        const value = event.target.value;
        setSelectedActivities(typeof value === 'string' ? value.split(',') : value);
    };

    const navigate = useNavigate();
    
    const columns = [
        { 
            field: 'activityDate', 
            headerName: 'Activity Date', 
            width: 150,
            valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY')
        },
        {
            field: 'activityName',
            headerName: 'Activity Name',
            width: 200
        },
        {
            field: 'summary',
            headerName: 'Summary',
            width: 300,
            renderCell: (params) => (
                <div style={{ 
                    whiteSpace: 'pre-wrap', 
                    wordBreak: 'break-word',
                    maxHeight: '100px',
                    overflow: 'hidden'
                }}>
                    {params.value}
                </div>
            )
        },
        {
            field: 'duration',
            headerName: 'Duration (Hours)',
            width: 150
        },
        {
            field: 'logAttendance',
            headerName: 'Attendance',
            width: 120
        }
    ];

    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />

            <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: "50px", justifyContent: "center", alignItems: "center" }}>
                <div style={{ height: 440, width: '100%' }}>
                    {/* Date Range Inputs */}
                    <TextField 
                        type="date" 
                        InputLabelProps={{ shrink: true }} 
                        className='addform' 
                        id="date-from" 
                        label="Date From" 
                        variant="outlined" 
                        style={{ width: "45%", marginRight: "10px" }} 
                        onChange={(e) => setDateFrom(e.target.value)} 
                        value={dateFrom} 
                    />
                    <TextField 
                        type="date" 
                        InputLabelProps={{ shrink: true }} 
                        className='addform' 
                        id="date-to" 
                        label="Date To" 
                        variant="outlined" 
                        style={{ width: "45%" }} 
                        onChange={(e) => setDateTo(e.target.value)} 
                        value={dateTo} 
                    />

                    {/* Activity Selection */}
                    <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <InputLabel id="activity-select-label">Select Activities (Leave empty to show all)</InputLabel>
                        <Select
                            labelId="activity-select-label"
                            id="activity-select"
                            multiple
                            value={selectedActivities}
                            onChange={handleActivityChange}
                            input={<OutlinedInput label="Select Activities (Leave empty to show all)" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {activityOptions.map((activity) => (
                                <MenuItem key={activity} value={activity}>
                                    {activity}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Search Button */}
                    <Button 
                        onClick={getData} 
                        className='addform' 
                        variant="contained" 
                        style={{ 
                            marginBottom: "10px", 
                            width: "100%", 
                            height: "50px", 
                            marginTop: "30px", 
                            backgroundColor: "#F21D2F" 
                        }}
                    >
                        Search Activities
                    </Button>

                    {/* Data Grid */}
                    <div style={{ height: 400, width: '100%', marginTop: '20px' }}>
                        <DataGrid 
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                            getRowId={(row) => row.doc || row.id}
                        />
                    </div>
                </div>
            </Box>
        </Box>
    )
}
